import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./ShareRedirect.css";
import logo from "../Assets/Images/audition/logo.png";

const ShareRedirect = () => {
  const { token } = useParams();
  const history = useHistory();
  const [status, setStatus] = useState("Connecting to Hello Super Stars...");

  useEffect(() => {
    if (!token) return;

    // Detect OS
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isMobile = isAndroid || isIOS;

    const playStoreUrl = "https://play.google.com/store/apps/details?id=com.hellosuperstars&hl=en";
    const appStoreUrl = "https://apps.apple.com/us/app/hellosuperstars/id6444334593";
    const appUrl = `hellosuperstars://hellosuperstars.com/share/${token}`;

    // 1. Attempt to launch the mobile app
    window.location.href = appUrl;

    // 2. Fallback if app doesn't open
    const timer = setTimeout(() => {
      // If we are still on this page after 2.5s, the app didn't open.
      if (isMobile) {
        setStatus("Redirecting to App Store...");
        if (isAndroid) {
          window.location.href = playStoreUrl;
        } else if (isIOS) {
          window.location.href = appStoreUrl;
        }
      } else {
        setStatus("Redirecting to web version...");
        // For desktop, fallback to web route
        try {
          const decodedString = decodeURIComponent(
            token.match(/.{1,2}/g).map((byte) => "%" + ("00" + byte).slice(-2)).join("")
          );
          const payload = JSON.parse(decodedString);
          if (payload.type && payload.id) {
            if (payload.type === 'post' || payload.type === 'general_post') {
              history.push(`/post/${payload.id}`);
            } else if (payload.type === 'podcast') {
              history.push(`/podcast/${payload.id}`);
            } else if (payload.type === 'audition') {
              history.push(`/audition/${payload.id}`);
            } else {
              setStatus("App required for this content.");
            }
          }
        } catch (err) {
          console.error("Failed to decode token", err);
          setStatus("App required for this content.");
        }
      }
    }, 2500);

    // Handle visibility change (if app opens, the page goes hidden)
    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearTimeout(timer);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [token, history]);

  return (
    <div className="share-redirect-container">
      <div className="share-redirect-content">
        <div className="brand-logo-pulse">
          <img src={logo} alt="Hello Super Stars" style={{ width: '95%', height: '95%', objectFit: 'contain' }} />
        </div>
        <h2 className="share-title">Hello Super Stars</h2>
        <p className="share-status">{status}</p>

        <div className="manual-action">
          <p className="action-hint">If nothing happens automatically:</p>
          <div className="app-store-buttons">
            <a href="https://play.google.com/store/apps/details?id=com.hellosuperstars&hl=en" className="store-btn play-store-btn">
              <i className="fab fa-google-play"></i>
              <div className="btn-text">
                <span className="small-text">GET IT ON</span>
                <span className="large-text">Google Play</span>
              </div>
            </a>
            <a href="https://apps.apple.com/us/app/hellosuperstars/id6444334593" className="store-btn app-store-btn">
              <i className="fab fa-apple"></i>
              <div className="btn-text">
                <span className="small-text">Download on the</span>
                <span className="large-text">App Store</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareRedirect;
